import { render, staticRenderFns } from "./SummaryBonus.vue?vue&type=template&id=86fa28ee&"
import script from "./SummaryBonus.vue?vue&type=script&lang=js&"
export * from "./SummaryBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports